// FinTrack — Authentication
import { state } from './state.js';
import { sb } from './supabase.js';
import { toast } from './ui.js';
import { showApp } from './nav.js';
import { clMdl } from './ui.js';

const SESSION_TTL_MS = 8 * 60 * 60 * 1000; // 8h

export async function doLogin() {
  const email = document.getElementById('aEmail').value.trim();
  const pass = document.getElementById('aPass').value;
  const err = document.getElementById('aerr');
  err.style.display = 'none';
  if (!email || !pass) { err.textContent = 'Unesite email i lozinku'; err.style.display = 'block'; return; }
  const btn = document.getElementById('aBtn');
  btn.disabled = true; btn.textContent = '';
  const spn = document.createElement('span'); spn.className = 'aspn'; btn.appendChild(spn);
  try {
    const { data, error } = await sb.rpc('login', { p_email: email, p_password: pass });
    if (error) throw error;
    if (!data || data.length === 0) throw { message: 'Pogrešan email ili lozinka' };
    const u = data[0];
    if (!u.is_active) throw { message: 'Vaš nalog je suspendovan. Kontaktirajte administratora.' };
    state.CU = u;
    window.__ft_cu = state.CU;
    sessionStorage.setItem('ft_user', JSON.stringify(u));
    sessionStorage.setItem('ft_login_ts', String(Date.now()));
    showApp();
    sb.rpc('log_audit', { p_user_id: state.CU.id, p_action: 'login', p_entity_type: 'user', p_entity_name: state.CU.email }).then(null, e => console.error('SBIS:', e));
  } catch (e) { err.textContent = e.message || 'Greška pri povezivanju sa serverom'; err.style.display = 'block'; }
  btn.disabled = false; btn.textContent = 'Prijavite se';
}

export function doLogout() {
  try { if (state.CU) sb.rpc('log_audit', { p_user_id: state.CU.id, p_action: 'logout', p_entity_type: 'user', p_entity_name: state.CU.email }); } catch(_) {}
  state.CU = null;
  window.__ft_cu = null;
  sessionStorage.removeItem('ft_user');
  sessionStorage.removeItem('ft_login_ts');
  document.getElementById('authOverlay').classList.remove('hidden');
  document.getElementById('app').style.display = 'none';
}

function isSessionExpired() {
  const ts = sessionStorage.getItem('ft_login_ts');
  if (!ts) return true;
  return (Date.now() - parseInt(ts)) > SESSION_TTL_MS;
}

export async function initSessionCheck() {
  // Provera sesije pri ucitavanju
  const s = sessionStorage.getItem('ft_user');
  if (s) {
    if (isSessionExpired()) {
      sessionStorage.removeItem('ft_user');
      sessionStorage.removeItem('ft_login_ts');
      return;
    }
    try {
      state.CU = JSON.parse(s);
      window.__ft_cu = state.CU;
      // Verify user still active via safe view
      try {
        const { data } = await sb.from('app_users_safe').select('is_active').eq('id', state.CU.id).maybeSingle();
        if (data && !data.is_active) {
          toast('Vaš nalog je suspendovan.', 'err');
          state.CU = null;
          window.__ft_cu = null;
          sessionStorage.removeItem('ft_user');
          sessionStorage.removeItem('ft_login_ts');
          return;
        }
      } catch (e) { /* offline — allow cached session */ }
      showApp();
    } catch (e) {}
  }

  // Periodična provera isteka sesije (svaki minut)
  setInterval(() => {
    if (state.CU && isSessionExpired()) {
      toast('Sesija je istekla. Prijavite se ponovo.', 'err');
      setTimeout(doLogout, 2000);
    }
  }, 60000);
}

export async function changeOwnPassword() {
  const old = document.getElementById('pwdOld').value;
  const nw = document.getElementById('pwdNew').value;
  const conf = document.getElementById('pwdConfirm').value;
  if (!old || !nw) { toast('Popunite sva polja', 'err'); return; }
  if (nw.length < 6) { toast('Nova lozinka mora imati bar 6 karaktera', 'err'); return; }
  if (nw !== conf) { toast('Lozinke se ne poklapaju', 'err'); return; }
  try {
    const { error } = await sb.rpc('change_own_password', { p_user_id: state.CU.id, p_old_password: old, p_new_password: nw });
    if (error) throw error;
    clMdl('mdlPwdChange');
    document.getElementById('pwdOld').value = '';
    document.getElementById('pwdNew').value = '';
    document.getElementById('pwdConfirm').value = '';
    toast('Lozinka uspešno promenjena');
  } catch (e) { toast(e.message || 'Greška', 'err'); }
}

// Keyboard shortcuts za login formu
document.getElementById('aEmail')?.addEventListener('keydown', e => { if (e.key === 'Enter') document.getElementById('aPass').focus(); });
document.getElementById('aPass')?.addEventListener('keydown', e => { if (e.key === 'Enter') doLogin(); });
